import { FunctionComponent } from 'react'
import { Box, Typography } from '@material-ui/core'
import styled from 'styled-components'
//@ts-ignore
import { useTheme } from 'styled-components'
import { darken } from 'polished'

interface CircleProfileCompletionBarProps {
  progress: number
}

export const CircleProfileCompletionBar: FunctionComponent<CircleProfileCompletionBarProps> = ({ progress }) => {
  const theme = useTheme()

  //@ts-ignore
  const CircleProgressBar = styled.div({
    background: () => {
      const angle = (360 * progress) / 100

      return `radial-gradient(${darken(0.25, theme.colors.supplementary)} 60%, transparent 61%),
            conic-gradient(transparent 0deg ${angle}deg, ${theme.colors.accent} ${angle}deg 360deg),
            conic-gradient(${theme.colors.primary} 0deg, ${theme.colors.primary})`
    },
    borderRadius: '50%',
    width: '3.1em',
    height: '3.1em'
  })
  return (
    <Box display="inline-flex" position="relative">
      <CircleProgressBar />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div">
          <Box color={theme.colors.accent1}>{Math.round(progress)}%</Box>
        </Typography>
      </Box>
    </Box>
  )
}
